export const colors = {
  "primary-950": "#460F04",
  "primary-900": "#82250C",
  "primary-800": "#A12A0B",
  "primary-700": "#CC3502",
  "primary-600": "#FF4D00",
  "primary-500": "#FF670A",
  "primary-400": "#FF8932",
  "primary-300": "#FFB46D",
  "primary-200": "#FFD3A5",
  "primary-100": "#FFEBD3",
  "primary-50": "#FFF6EC",
  "primary-alpha-24": "#FE31113D",
  "primary-alpha-20": "#FF4D0033",
  "primary-alpha-16": "#FE311128",
  "primary-alpha-10": "#FF4D001A",
  "primary-alpha-5": "#FF4D000D",
  "primary-alpha-0": "#FE311100",
  "secondary-950": "#04314D",
  "secondary-900": "#064D74",
  "secondary-800": "#005C8D",
  "secondary-700": "#006DAB",
  "secondary-600": "#008AD4",
  "secondary-500": "#00B2FF",
  "secondary-400": "#2CC4FF",
  "secondary-300": "#75D7FF",
  "secondary-200": "#B6E8FF",
  "secondary-100": "#DEF2FF",
  "secondary-50": "#EFF9FF",
  "secondary-alpha-20": "#008AD433",
  "secondary-alpha-10": "#008AD41A",
  "secondary-alpha-5": "#008AD40D",
  "neutral-950": "#0E121B",
  "neutral-900": "#181B25",
  "neutral-800": "#222530",
  "neutral-700": "#2B303B",
  "neutral-600": "#525866",
  "neutral-500": "#717784",
  "neutral-400": "#99A0AE",
  "neutral-300": "#CACFD8",
  "neutral-200": "#E1E4EA",
  "neutral-100": "#F2F5F8",
  "neutral-50": "#F5F7FA",
  "neutral-0": "#FFFFFF",
  "blue-950": "#122368",
  "blue-900": "#182F8B",
  "blue-800": "#1F3BAD",
  "blue-700": "#2547D0",
  "blue-600": "#3559E9",
  "blue-500": "#335CFF",
  "blue-400": "#6895FF",
  "blue-300": "#97BAFF",
  "blue-200": "#C0D5FF",
  "blue-100": "#D5E2FF",
  "blue-50": "#EBF1FF",
  "orange-950": "#683412",
  "orange-900": "#8B4618",
  "orange-800": "#AD581F",
  "orange-700": "#D06925",
  "orange-600": "#E97D35",
  "orange-500": "#FF9147",
  "orange-400": "#FFA468",
  "orange-300": "#FFC197",
  "orange-200": "#FFD9C0",
  "orange-100": "#FFE6D5",
  "orange-50": "#FFF3EB",
  "red-950": "#681219",
  "red-900": "#8B1822",
  "red-800": "#AD1F2B",
  "red-700": "#D02533",
  "red-600": "#E93544",
  "red-500": "#FB3748",
  "red-400": "#FF6875",
  "red-300": "#FF97A0",
  "red-200": "#FFC0C5",
  "red-100": "#FFD5D8",
  "red-50": "#FFEBEC",
  "green-950": "#0B4627",
  "green-900": "#16643B",
  "green-800": "#1A7544",
  "green-700": "#178C4E",
  "green-600": "#1DAF61",
  "green-500": "#1FC16B",
  "green-400": "#3EE089",
  "green-300": "#84EBB4",
  "green-200": "#C2F5DA",
  "green-100": "#D0FBE9",
  "green-50": "#E0FAEC",
  "yellow-950": "#624C18",
  "yellow-900": "#86661D",
  "yellow-800": "#A78025",
  "yellow-700": "#C99A2C",
  "yellow-600": "#E6A819",
  "yellow-500": "#F6B51E",
  "yellow-400": "#FFD268",
  "yellow-300": "#FFE097",
  "yellow-200": "#FFECC0",
  "yellow-100": "#FFEFCC",
  "yellow-50": "#FFFAEB",
  "purple-950": "#351A75",
  "purple-900": "#3D1D86",
  "purple-800": "#4C25A7",
  "purple-700": "#5B2CC9",
  "purple-600": "#693EE0",
  "purple-500": "#7D52F4",
  "purple-400": "#8C71F6",
  "purple-300": "#A897FF",
  "purple-200": "#CAC0FF",
  "purple-100": "#DCD5FF",
  "purple-50": "#EFEBFF",
  "sky-950": "#124B68",
  "sky-900": "#18658B",
  "sky-800": "#1F7EAD",
  "sky-700": "#2597D0",
  "sky-600": "#35ADE9",
  "sky-500": "#47C2FF",
  "sky-400": "#68CDFF",
  "sky-300": "#97DCFF",
  "sky-200": "#C0EAFF",
  "sky-100": "#D5F1FF",
  "sky-50": "#EBF8FF",
  "pink-950": "#68123D",
  "pink-900": "#8B1852",
  "pink-800": "#AD1F66",
  "pink-700": "#D0257A",
  "pink-600": "#E9358F",
  "pink-500": "#FB4BA3",
  "pink-400": "#FF68B3",
  "pink-300": "#FF97CB",
  "pink-200": "#FFC0DF",
  "pink-100": "#FFD5EA",
  "pink-50": "#FFEBF4",
  "teal-950": "#0B463E",
  "teal-900": "#16645A",
  "teal-800": "#1A7569",
  "teal-700": "#178C7D",
  "teal-600": "#1DAF9C",
  "teal-500": "#22D3BB",
  "teal-400": "#3FDEC9",
  "teal-300": "#84EBDD",
  "teal-200": "#C2F5EE",
  "teal-100": "#D0FBF5",
  "teal-50": "#E4FBF8",
  "alpha-colors-black-alpha-24": "#0E121B3D",
  "alpha-colors-black-alpha-16": "#0E121B28",
  "alpha-colors-black-alpha-10": "#0E121B19",
  "alpha-colors-black-alpha-0": "#0E121B00",
  "alpha-colors-neutral-alpha-24": "#99A0AE3D",
  "alpha-colors-neutral-alpha-16": "#99A0AE28",
  "alpha-colors-neutral-alpha-10": "#99A0AE19",
  "alpha-colors-neutral-alpha-0": "#99A0AE00",
  "alpha-colors-white-alpha-24": "#FFFFFF3D",
  "alpha-colors-white-alpha-20": "#FFFFFF33",
  "alpha-colors-white-alpha-16": "#FFFFFF28",
  "alpha-colors-white-alpha-10": "#FFFFFF19",
  "alpha-colors-white-alpha-0": "#FFFFFF00",
  "alpha-colors-blue-alpha-24": "#476CFF3D",
  "alpha-colors-blue-alpha-16": "#476CFF28",
  "alpha-colors-blue-alpha-10": "#476CFF19",
  "alpha-colors-blue-alpha-0": "#476CFF00",
  "alpha-colors-orange-alpha-24": "#FF91473D",
  "alpha-colors-orange-alpha-16": "#FF914728",
  "alpha-colors-orange-alpha-10": "#FF914719",
  "alpha-colors-orange-alpha-0": "#FF914700",
  "alpha-colors-red-alpha-24": "#FB37483D",
  "alpha-colors-red-alpha-16": "#FB374828",
  "alpha-colors-red-alpha-10": "#FB374819",
  "alpha-colors-red-alpha-0": "#FB374800",
  "alpha-colors-green-alpha-24": "#1FC16B3D",
  "alpha-colors-green-alpha-16": "#1FC16B28",
  "alpha-colors-green-alpha-10": "#1FC16B19",
  "alpha-colors-green-alpha-0": "#1FC16B00",
  "alpha-colors-yellow-alpha-24": "#FBC64B3D",
  "alpha-colors-yellow-alpha-16": "#FBC64B28",
  "alpha-colors-yellow-alpha-10": "#FBC64B19",
  "alpha-colors-yellow-alpha-0": "#FBC64B00",
  "alpha-colors-purple-alpha-24": "#784DEF3D",
  "alpha-colors-purple-alpha-16": "#784DEF28",
  "alpha-colors-purple-alpha-10": "#784DEF19",
  "alpha-colors-purple-alpha-0": "#784DEF00",
  "alpha-colors-sky-alpha-24": "#47C2FF3D",
  "alpha-colors-sky-alpha-16": "#47C2FF28",
  "alpha-colors-sky-alpha-10": "#47C2FF19",
  "alpha-colors-sky-alpha-0": "#47C2FF00",
  "alpha-colors-pink-alpha-24": "#FB4BA33D",
  "alpha-colors-pink-alpha-16": "#FB4BA328",
  "alpha-colors-pink-alpha-10": "#FB4BA319",
  "alpha-colors-pink-alpha-0": "#FB4BA300",
  "alpha-colors-teal-alpha-24": "#22D3BB3D",
  "alpha-colors-teal-alpha-16": "#22D3BB28",
  "alpha-colors-teal-alpha-10": "#22D3BB19",
  "alpha-colors-teal-alpha-0": "#22D3BB00",
};
